<form
  [formGroup]="form"
  (ngSubmit)="onSubmit()"
  class="dynamic-form"
  [attr.data-mode]="currentMode"
>
  <div class="form-sections">
    <div
      *ngFor="let section of visibleSections"
      class="form-section"
      [ngClass]="section.cssClass"
      [class.collapsed]="section.collapsed"
    >
      <div *ngIf="section.title" class="section-header">
        <h5 class="section-title">{{ section.title }}</h5>
        <p *ngIf="section.description" class="section-description">{{ section.description }}</p>
      </div>

      <div
        class="section-content w-100"
        [ngClass]="getSectionLayoutClass(section)"
        [ngStyle]="getSectionGapStyle(section)"
      >
        <ng-container *ngFor="let field of section.fields">
          <div
            *ngIf="isFieldVisible(field)"
            [ngClass]="getGridClass(field)"
            class="form-field-wrapper"
          >
            <ng-container [ngSwitch]="field.controlType">
              <!-- Input Field -->
              <app-input
                *ngSwitchCase="'input'"
                [formControlName]="field.formControlName"
                [config]="field.config"
                [validation]="field.validation"
              >
              </app-input>

              <!-- Select Field -->
              <app-select
                *ngSwitchCase="'select'"
                [formControlName]="field.formControlName"
                [config]="field.config"
              >
              </app-select>

              <!-- Textarea Field -->
              <app-textarea
                *ngSwitchCase="'textarea'"
                [formControlName]="field.formControlName"
                [config]="field.config"
                [validation]="field.validation"
              >
              </app-textarea>

              <!-- Checkbox Field -->
              <app-checkbox
                *ngSwitchCase="'checkbox'"
                [formControlName]="field.formControlName"
                [config]="field.config"
                (valueChange)="onFieldValueChange(field.id, $event)"
              >
              </app-checkbox>

              <!-- Radio Field -->
              <app-radio
                *ngSwitchCase="'radio'"
                [formControlName]="field.formControlName"
                [config]="field.config"
              >
              </app-radio>

              <!-- File Upload Field -->
              <app-file-upload
                *ngSwitchCase="'file'"
                [formControlName]="field.formControlName"
                [componentConfig]="field.config"
                (fileSelectEvent)="onFieldValueChange(field.id, $event)"
              >
              </app-file-upload>

              <!-- Date Field - FIXED: Removed (valueChange) binding -->
              <app-datepicker
                *ngSwitchCase="'date'"
                [formControlName]="field.formControlName"
                [config]="field.config"
                [validation]="field.validation"
              ></app-datepicker>

              <!-- Time Field - FIXED: Removed (valueChange) binding -->
              <app-timepicker
                *ngSwitchCase="'time'"
                [formControlName]="field.formControlName"
                [config]="field.config"
                [validation]="field.validation"
              ></app-timepicker>

              <!-- Color Field - FIXED: Removed (valueChange) binding -->
              <app-colorpicker
                *ngSwitchCase="'color'"
                [formControlName]="field.formControlName"
                [config]="field.config"
                [validation]="field.validation"
              ></app-colorpicker>

              <!-- Field Group -->
              <app-field-group
                *ngSwitchCase="'fieldgroup'"
                [config]="field.fieldGroupConfig!"
                [parentForm]="form"
                [formArrayName]="field.formControlName"
              >
              </app-field-group>
            </ng-container>
          </div>
        </ng-container>
      </div>
    </div>
  </div>

  <!-- Form Actions - Only show in page mode -->
  <div class="form-actions" *ngIf="showActions">
    <button
      type="button"
      kendoButton
      [fillMode]="'outline'"
      [themeColor]="'base'"
      [disabled]="disabled"
      (click)="onCancel()"
    >
      {{ config.cancelText || 'Cancel' }}
    </button>
    <button
      type="submit"
      kendoButton
      [fillMode]="'solid'"
      [themeColor]="'primary'"
      [disabled]="(form.invalid && config.validateOnSubmit !== false) || disabled"
    >
      <span *ngIf="disabled" class="k-icon k-i-loading"></span>
      {{ disabled ? 'Processing...' : config.submitText || 'Submit' }}
    </button>
  </div>
</form>
